var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:({background: _vm.$store.getters.getColorPalette().background2ColorCode}),attrs:{"fluid":""}},[_c('div',{ref:"vis"})])
}
var staticRenderFns = []

export { render, staticRenderFns }